import { createSlice } from "@reduxjs/toolkit";
import { getApplicationResults, getApplications } from "./Thunk";

export const applicationResults = createSlice({
  name: "applicationResults",
  initialState: {
    applications: null,
    applicationResults: null,
    isUpdateOperation: false,
    isLoading: false,
  },
  reducers: {
    ClearApplicationResults(state, action) {
      state.applicationResults = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getApplicationResults.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getApplicationResults.fulfilled, (state, action) => {
      state.isLoading = false;
      state.applicationResults = action.payload;
    });

    builder.addCase(getApplications.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getApplications.fulfilled, (state, action) => {
      state.isLoading = false;
      state.applications = action.payload;
    });
  },
});

export const { ClearApplicationResults } = applicationResults.actions;

export default applicationResults.reducer;
